import { mixpanel } from '@hive/track';
import {
  type TelemetryEventMap,
  TelemetryProvider,
} from '@blocksuite/hive/shared/services';
import type { ExtensionType } from '@blocksuite/hive/store';

export function getTelemetryExtension(): ExtensionType {
  return {
    setup: di => {
      di.addImpl(TelemetryProvider, () => ({
        track: <T extends keyof TelemetryEventMap>(
          eventName: T,
          props: TelemetryEventMap[T]
        ) => {
          mixpanel.track(eventName as string, props as Record<string, unknown>);
        },
      }));
    },
  };
}
